<div class="flex flex-wrap justify-start gap-6 w-full mb-8">
    <!-- Skeleton loader -->
    <ng-container *ngIf="loading">
        <div *ngFor="let _ of [1,2,3,4]"
            class="flex flex-1 min-w-[240px] flex-row items-center gap-5 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
            <div class="h-14 w-14 shrink-0 rounded-xl bg-slate-200 animate-pulse"></div>
            <div class="flex flex-col items-start gap-1">
                <div class="h-3 w-24 rounded bg-slate-200 animate-pulse"></div>
                <div class="h-7 w-20 rounded bg-slate-200 animate-pulse"></div>
            </div>
        </div>
    </ng-container>

    <!-- Cards -->
    <ng-container *ngIf="!loading">
        <ng-container *ngFor="let card of cards">
            <div class="recap-card group flex flex-1 min-w-[240px] cursor-pointer flex-row items-center gap-5
                        rounded-2xl border border-slate-100 bg-white p-6 shadow-sm
                        transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
                        hover:-translate-y-1 hover:shadow-lg relative overflow-hidden"
                [ngClass]="{
                    'card-green': card.title === 'Quote incassate' || card.title === 'Totale società attive' || card.title === 'Iscritti stagione',
                    'card-red': card.title === 'Quote da incassare' || card.title === 'Totale società da approvare',
                    'card-blue': card.title === 'Totale incassato' || card.title === 'Incasso abbonamenti' || card.title === 'Totale società' || card.title === 'Totale atleti nelle società'
                }"
                (click)="onCardClick(card)">

                <div *ngIf="card.icon"
                    class="card-icon flex h-14 w-14 shrink-0 items-center justify-center rounded-xl
                           bg-slate-100 text-slate-500 text-[1.75rem] shadow-sm
                           transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
                           group-hover:scale-110">
                    <i class="bi" [ngClass]="card.icon"></i>
                </div>

                <div class="flex flex-col items-start">
                    <div class="card-title text-xs font-bold uppercase tracking-wide mb-1 text-slate-400 text-left">
                        {{ card.title }}
                    </div>
                    <div class="flex items-baseline gap-1.5">
                        <span class="card-value text-[1.6rem] font-extrabold leading-tight text-slate-800">{{ card.quantity }}</span>
                        <span *ngIf="card.subtitle" class="whitespace-nowrap text-sm font-medium text-slate-500">{{ card.subtitle }}</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<!-- Chart -->
<div *ngIf="!agentPage" class="px-9 pb-9">
    <div class="flex items-center justify-between mb-6">
        <span class="text-xl font-semibold text-gray-900">Pagamenti</span>
        <div class="flex gap-2" role="group">
            <button type="button"
                class="rounded-md border px-4 py-2 text-sm font-medium transition-colors"
                [ngClass]="selectedPeriod === 'week'
                    ? 'filter-btn-active text-white'
                    : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-700'"
                (click)="setPeriod('week')">Settimana</button>

            <button type="button"
                class="rounded-md border px-4 py-2 text-sm font-medium transition-colors"
                [ngClass]="selectedPeriod === 'month'
                    ? 'filter-btn-active text-white'
                    : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-700'"
                (click)="setPeriod('month')">Mese</button>

            <button type="button"
                class="rounded-md border px-4 py-2 text-sm font-medium transition-colors"
                [ngClass]="selectedPeriod === 'season'
                    ? 'filter-btn-active text-white'
                    : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-700'"
                (click)="setPeriod('season')">Stagione Sportiva</button>
        </div>
    </div>
    <div class="min-h-[350px]" id="chart">
        <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart"
            [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis"
            [xaxis]="chartOptions.xaxis" [stroke]="chartOptions.stroke" [fill]="chartOptions.fill"
            [tooltip]="chartOptions.tooltip"></apx-chart>
    </div>
</div>
